import { useCallback, useRef, useState } from 'react';
import { useUnmount } from 'react-use';

export default function useIntervalIncreaseStep({
  initStep,
  maxStep,
  interval,
  stepSize,
}: {
  initStep: number;
  maxStep: number;
  interval: number;
  stepSize: number;
}) {
  const timerRef = useRef<NodeJS.Timeout>();
  const [step, setStep] = useState(initStep);

  useUnmount(() => clearIntervalIncrease());

  const clearIntervalIncrease = useCallback(() => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
  }, []);

  const startIntervalIncrease = useCallback(() => {
    clearIntervalIncrease();
    timerRef.current = setInterval(
      () => setStep((prev) => Math.min(maxStep - stepSize, prev + stepSize)),
      interval
    );
  }, [clearIntervalIncrease, interval, maxStep, stepSize]);

  const setToMaxStep = useCallback(() => {
    clearIntervalIncrease();
    setStep(maxStep);
  }, [clearIntervalIncrease, maxStep]);

  const resetStep = useCallback(() => {
    setStep(initStep);
  }, [initStep]);

  return {
    startIntervalIncrease,
    setToMaxStep,
    resetStep,
    step,
  };
}
